import { FC } from 'react';

import { CheckableCardScrollableContainer } from '@hh.ru/magritte-ui';

import CardEdProgramSmall from 'src/components/CardEdProgram/CardEdProgramSmall';
import { EdProgramDto } from 'src/types/EdProgram';

import styles from './styles.less';

interface CarouselCoursesProps {
    edProgram: EdProgramDto[];
}

const CarouselCourseselPrograms: FC<CarouselCoursesProps> = ({ edProgram }) => {
    return (
        <CheckableCardScrollableContainer>
            <div className={styles.coursesList}>
                {edProgram.map((course) => (
                    <CardEdProgramSmall key={course.id} edProgram={course} />
                ))}
            </div>
        </CheckableCardScrollableContainer>
    );
};

export default CarouselCourseselPrograms;
